import { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import LoginPage from '@/pages/LoginPage';
import Dashboard from '@/pages/Dashboard';
import GrantDiscovery from '@/pages/GrantDiscovery';
import GrantTracker from '@/pages/GrantTracker';
import ExpenseMapper from '@/pages/ExpenseMapper';
import Reports from '@/pages/Reports';
import AICopilot from '@/pages/AICopilot';
import Layout from '@/components/Layout';

function App() {
  const [token, setToken] = useState(localStorage.getItem('ngo_token'));
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('ngo_user') || 'null'));

  const handleLogin = (newToken, newUser) => {
    localStorage.setItem('ngo_token', newToken);
    localStorage.setItem('ngo_user', JSON.stringify(newUser));
    setToken(newToken);
    setUser(newUser);
  };

  const handleLogout = () => {
    localStorage.removeItem('ngo_token');
    localStorage.removeItem('ngo_user');
    setToken(null);
    setUser(null);
  };

  const defaultUser = { name: 'Guest User', role: 'admin' };

  return (
    <BrowserRouter>
      <Layout user={user || defaultUser} onLogout={handleLogout}>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/discovery" element={<GrantDiscovery />} />
          <Route path="/grants" element={<GrantTracker />} />
          <Route path="/expenses" element={<ExpenseMapper />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/ai-copilot" element={<AICopilot />} />
          <Route path="/login" element={<LoginPage onLogin={handleLogin} />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
